import { apiFetch } from "../apiClient";
import type {
  AdminAuditPage,
  AdminTenant,
  CreateAdminTenantRequest,
  MemberAnalytics,
  MemberPage,
  UpdateTenantStatusRequest,
} from "../../types";

export function listAdminTenants(token: string): Promise<{ tenants: AdminTenant[] }> {
  return apiFetch("/admin/tenants", { token });
}

export interface CreateAdminTenantResponse {
  tenant: AdminTenant;
  ownerInvitationSent: boolean;
}

export function createAdminTenant(
  token: string,
  payload: CreateAdminTenantRequest,
): Promise<CreateAdminTenantResponse> {
  return apiFetch("/admin/tenants", { method: "POST", body: payload, token });
}

export function listAdminMembers(
  token: string,
  tenantId: string,
  params: { limit?: number; cursor?: string } = {},
): Promise<MemberPage> {
  const query = new URLSearchParams();
  query.set("limit", String(params.limit ?? 50));
  if (params.cursor) query.set("cursor", params.cursor);
  return apiFetch(`/admin/tenants/${encodeURIComponent(tenantId)}/members?${query.toString()}`, { token });
}

export function getAdminAnalytics(token: string, tenantId: string): Promise<{ analytics: MemberAnalytics }> {
  return apiFetch(`/admin/tenants/${encodeURIComponent(tenantId)}/analytics`, { token });
}

export function updateAdminTenantStatus(
  token: string,
  tenantId: string,
  payload: UpdateTenantStatusRequest,
): Promise<{ tenant: AdminTenant }> {
  return apiFetch(`/admin/tenants/${encodeURIComponent(tenantId)}/status`, {
    method: "PATCH",
    token,
    body: payload,
  });
}

export function listAdminAuditEvents(
  token: string,
  tenantId: string,
  params: { limit?: number; cursor?: string } = {},
): Promise<AdminAuditPage> {
  const query = new URLSearchParams();
  query.set("limit", String(params.limit ?? 50));
  if (params.cursor) query.set("cursor", params.cursor);
  return apiFetch(`/admin/tenants/${encodeURIComponent(tenantId)}/audit?${query.toString()}`, { token });
}
